import React, { Component } from 'react'
import Question from './Question'
import Option from './Option'

export default class VideoQuiz extends Component {

  constructor() {
    super();
    this.state = {
      currentQuestion: 1,
      currentQuestionAnswered: false,
      totalQuestions: 6,
      userName: "",
      email: "",
      answers: [],
      selected: [],
      button: <button onClick={this.nextQuestion} className="btn btn-lg btn-secondary waves-effect waves-light">Next <i className="fas fa-arrow-right"></i></button>,
    };
    this.myRef = React.createRef()
  }

  setUserName = (e) => {
    let userName = e.target.value
    if (userName.length) {
      this.setState({
        userName,
        currentQuestionAnswered: true
      })
    }
  }

  setEmail = (e) => {
    let email = e.target.value
    if (email.length) {
      this.setState({email})
    }
  }

  isCurrentQuestion = (question) => {
    return question === this.state.currentQuestion
  }

  nextQuestion = () => {
    if (this.state.currentQuestionAnswered) {
      console.log("Try 1")
      let currentQuestion = this.state.currentQuestion + 1
      // if (currentQuestion > this.state.totalQuestions) {
        //   currentQuestion = 0
        //   let smartType = this.state.answers.reduce((sum, element) => {
          //     return sum + element;
          //   })
          //   smartType = Math.round(smartType / 3)
          //   console.log(smartType)
          //   window.location = "/lagos-in-july/results?smartType=" + smartType + "&smartName=" + this.state.userName + "&email=" + this.state.email
          //   this.setState({
            //     currentQuestion,
            //     currentQuestionAnswered: true,
            //     button: <a href={"/lagos-in-july/results?smartType=" + smartType + "&smartName=" + this.state.userName + "&email=" + this.state.email} className="btn btn-lg btn-secondary waves-effect waves-light">See Results! <i className="fas fa-arrow-right"></i></a>
            //   })
            //   return
            // }
            this.setState({
              currentQuestion,
              currentQuestionAnswered: false
            })
            console.log("Try 2")
          }
      console.log("Try 3")
  }
  
  selectOption = (question, answer) => {
    let answers = this.state.answers
    answers[question] = answer
    let currentQuestion = this.state.currentQuestion + 1
    this.setState({
      answers,
      currentQuestion
    })
    console.log(this.state.currentQuestion)
  }

  scrollToMyRef = () => window.scrollTo(0, this.myRef.current.offsetTop)

  render() {
    return (
      <div>
        <section id="hero" className={this.isCurrentQuestion(1) ? "" : ""}>
          <div className="container">
            <div className="row" ref={this.myRef}>
              <div className="col-sm-12">
                
                {/* <Question show={this.isCurrentQuestion(1)}>
                  <div className="col-md-6">
                    <SoundcloudEmbed trackId="668234681" />
                  </div>
                  <div className="form-group col-md-6">
                    <h3 className="col-sm-12">Just your name & email</h3>
                    <input 
                      placeholder="Your Name*" 
                      onChange = { this.setUserName }
                      value = { this.state.userName }
                      id="name" 
                      name="name" 
                      type="text" 
                      className="form-control" 
                      maxLength="10"
                    />
                    <input 
                      placeholder="Your Email" 
                      onChange = { this.setEmail }
                      value = { this.state.email }
                      id="email" 
                      name="email" 
                      type="text" 
                      className="form-control" 
                    />
                    <p className="col-12">We'll use this to customize your stamp.</p>
                  </div>
                </Question>
            */}
                <Question show={this.isCurrentQuestion(1)}>
                  <div className="col-12 text-center">
                    <h3 className="col-sm-12">
                      Q1: Ma fi ____ yen
                    </h3>
                    <Option  
                      onClick={this.selectOption} 
                      question={1} 
                      answer={1}
                      value="Owo" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={1} 
                      answer={0}
                      value="Gbe bodi e" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={1} 
                      answer={0}
                      value="Sanwo" 
                    />
                  </div>

                </Question>
                
                <Question show={this.isCurrentQuestion(2)}>
                  <div className="col-12 text-center">
                    <h3 className="col-sm-12">
                      Q2: 49 sitting 99 standing, oh my ____ o
                    </h3>
                    <Option  
                      onClick={this.selectOption} 
                      question={2} 
                      answer={0}
                      value="Man" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={2} 
                      answer={0}
                      value="Woman" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={2} 
                      answer={1}
                      value="God" 
                    />
                  </div>

                </Question>
                
                <Question show={this.isCurrentQuestion(3)}>
                  <div className="col-12 text-center">
                    <h3 className="col-sm-12">
                      Q3: Mo fe ra versa, mo fe ra ____
                    </h3>
                    <Option  
                      onClick={this.selectOption} 
                      question={3} 
                      answer={0}
                      value="Vera" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={3} 
                      answer={1}
                      value="Versace" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={3} 
                      answer={0}
                      value="Meta" 
                    />
                  </div>

                </Question>
                
                <Question show={this.isCurrentQuestion(4)}>
                  <div className="col-12 text-center">
                    <h3 className="col-sm-12">
                      Q4: Monkey no get ____
                    </h3>
                    <Option  
                      onClick={this.selectOption} 
                      question={4} 
                      answer={0}
                      value="Banana" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={4} 
                      answer={1}
                      value="Skills" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={4} 
                      answer={0}
                      value="Friends" 
                    />
                  </div>

                </Question>
                
                <Question show={this.isCurrentQuestion(5)}>
                  <div className="col-12 text-center">
                    <h3 className="col-sm-12">
                      Q1: I get money before no be ____ o
                    </h3>
                    <Option  
                      onClick={this.selectOption} 
                      question={5} 
                      answer={0}
                      value="Joke" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={5} 
                      answer={0}
                      value="Story Story" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={5} 
                      answer={1}
                      value="Property" 
                    />
                  </div>

                </Question>
                
                <Question show={this.isCurrentQuestion(6)}>
                  <div className="col-12 text-center">
                    <h3 className="col-sm-12">
                      Q6: Waiting for ____ and okada
                    </h3>
                    <Option  
                      onClick={this.selectOption} 
                      question={6} 
                      answer={1}
                      value="Danfo" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={6} 
                      answer={0}
                      value="Molue" 
                    />

                    <Option  
                      onClick={this.selectOption} 
                      question={6} 
                      answer={0}
                      value="Bus" 
                    />
                  </div>

                </Question>

                <div className="text-center">
                  {/* {this.state.button} */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
